module.exports = __webpack_public_path__ + "static/media/1018016.c51e0627.png";